module.exports = __webpack_public_path__ + "static/img/iChat@2x.5c7c8df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/new_home/iChat@2x.png
// module id = 464
// module chunks = 0